export const VitalSyncControllerFactory = ({
  vitalSyncService,
}: {
  vitalSyncService: IVitalSyncService;
}) => {
  const extractVitals: IExtractVitalsController = async ({
    file,
    patient_id,
    clinic_id,
  }) => {
    const payload: IExtractVitalsAPIPayload = {
      file,
      patient_id,
      clinic_id,
    };

    const response = await vitalSyncService.extractVitals(payload);
    return response;
  };

  const submitVitalsToPCC: ISubmitVitalsToPCCController = async ({
    patient_id,
    vitals,
    clinic_id,
    nurse_name,
    nurse_signature,
  }) => {
    const payload: ISubmitVitalsToPCCAPIPayload = {
      patient_id,
      vitals,
      clinic_id: clinic_id,
      nurse_name,
      nurse_signature,
    };
    const response = await vitalSyncService.submitVitalsToPCC(payload);
    return response;
  };

  const getPCCSubmissionStatistics: IGetPCCSubmissionStatisticsController =
    async (payload) => {
      const response = await vitalSyncService.getPCCSubmissionStatistics(
        payload
      );
      return response;
    };

  const getPCCQueueList: IGetPCCQueueListController = async (payload) => {
    const response = await vitalSyncService.getPCCQueueList(payload);
    return response;
  };

  const getNeedReviewVitals: IGetNeedReviewVitalsController = async (payload) =>
    vitalSyncService.getNeedReviewVitals(payload);

  const updateNeedReviewVitals: IUpdateNeedReviewVitalsController = async (
    payload
  ) => vitalSyncService.updateNeedReviewVitals(payload);

  return {
    extractVitals,
    submitVitalsToPCC,
    getPCCSubmissionStatistics,
    getPCCQueueList,
    getNeedReviewVitals,
    updateNeedReviewVitals,
  };
};
